import { useIsClient } from 'usehooks-ts'

import IconFavoriteDisable from '@/components/assets/icon_favorite_disable.svg'
import IconFavoriteEnable from '@/components/assets/icon_favorite_enable.svg'
import ViverseButton from '@/components/ViverseButton'
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { cn } from '@/lib/utils'

type LikeButtonProps = {
  className?: string
  iconClassName?: string
}

export default function LikeButton({ className, iconClassName }: LikeButtonProps) {
  const { toggleLikeRoom, isLikeButtonEnabled, roomData } = useCheckEnterRoomContext()
  const isLiked = roomData.is_liked
  const IconLike = isLiked ? IconFavoriteEnable : IconFavoriteDisable
  const isClient = useIsClient()

  return (
    <ViverseButton
      className={cn('group flex min-w-fit gap-2', className)}
      variant="filter"
      onClick={toggleLikeRoom}
      disabled={!isLikeButtonEnabled || !isClient}
    >
      <IconLike
        className={cn(
          'group-hover:[&>path]:fill-vive-brand-50 size-[18px]',
          isLiked && '[&>path]:fill-vive-brand-50',
          iconClassName,
        )}
      />
    </ViverseButton>
  )
}
